import { useEffect, useState } from 'react';

import { WebformEndpoint, webformEndpointsApi } from 'apis/webformEndpoints';

export function useFormEndpoints(
  formId: string | undefined,
): ReadonlyArray<WebformEndpoint> {
  const [endpoints, setEndpoints] = useState<ReadonlyArray<WebformEndpoint>>(
    [],
  );
  const [readFormEndpoint] =
    webformEndpointsApi.endpoints.readWebformEndpoints.useLazyQuery();

  useEffect(() => {
    if (!formId) {
      setEndpoints([]);
    }

    async function fetchEndpoints() {
      try {
        const endpoints =
          (await readFormEndpoint({ formIntegrationId: formId })).data?.data
            .endpoints || [];

        setEndpoints(endpoints);
      } catch (error) {
        setEndpoints([]);
      }
    }

    fetchEndpoints();
  }, [formId, readFormEndpoint]);

  return endpoints;
}
